import React, { createRef } from 'react';
import { searchLink } from '../../documents/data';

type SearchFormProps = {
  className?: string;
  ifFocusableOnLoad?: boolean;
  toShowCopyOnFocus: boolean;
  placeholder?: string;
  toShowSecurityMessage?: boolean;
  id: string;
  homepage?: boolean;
};
type SearchFormState = {
  toShowCopy: boolean;
};
class SearchForm extends React.Component<SearchFormProps, SearchFormState> {
  inp: React.RefObject<HTMLInputElement>;

  toShowSecurityMessage: boolean = true;

  constructor(props: SearchFormProps) {
    const { toShowCopyOnFocus } = props; // Destructure the toShowCopyOnFocus prop
    super(props);
    this.inp = createRef<HTMLInputElement>();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);

    this.state = {
      toShowCopy: !toShowCopyOnFocus
    };
    this.toShowSecurityMessage = props.toShowSecurityMessage ?? true;
  }

  componentDidMount(): void {
    if (this.props.ifFocusableOnLoad && this.inp.current) {
      this.inp.current.focus();
    }
  }

  handleFocus() {
    if (this.props.toShowCopyOnFocus) {
      this.setState(() => ({
        toShowCopy: true
      }));
    }
  }

  handleBlur() {
    if (this.props.toShowCopyOnFocus) {
      this.setState(() => ({
        toShowCopy: false
      }));
    }
  }

  handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const query = this.inp.current?.value || '';
    const url = `${searchLink}#q=${encodeURIComponent(query)}${this.props?.homepage ? '&tmpl=home' : ''}`;
    window.location.href = url;
  }

  render() {
    const cl = this.props.className || '';
    return (
      <>
        <form
          className={`bg-white border ${cl}`}
          name="global-form"
          method="get"
          autoComplete="off"
          spellCheck="false"
          onSubmit={this.handleSubmit}>
          <div
            className="input-group"
            id={this.props.id}>
            <label
              htmlFor={`${this.props.id}-input`}
              className="visually-hidden">
              {this.props.placeholder || 'Search'}
            </label>
            <input
              id={`${this.props.id}-input`}
              ref={this.inp}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              type="text"
              className="form-control border-end-0 border border-white"
              placeholder={this.props.placeholder || 'Search'}
              name="q"
            />
            <button
              className="btn ecs-font-icon-act-search border-0 text-secondary h5 mb-0 "
              type="submit"
              aria-label={this.props.placeholder || 'Search'}
            />
          </div>
        </form>
        {this.state.toShowCopy && this.toShowSecurityMessage && (
          <p className="p-2 body-text-xs mb-0">
            Don’t enter personal info like your SSN, email or phone number
          </p>
        )}
      </>
    );
  }
}
export default SearchForm;
